export default __webpack_public_path__ + "static/media/settings.dd04440c.md";